import { ForgotPassword } from 'pages/forgotPassword'

export const ForgotPasswordManagementRoute = () => {
  return <ForgotPassword />;
}